import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ParticipantOffersUrlBuilderService } from './participant-offers-url-builder.service';
import { Observable } from 'rxjs';
import { CustomerEmployeeShort } from '../models/customer-employee-short';
import { AppUrls } from '../app-urls';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private http: HttpClient, private urlBuilder: ParticipantOffersUrlBuilderService) {}

  /**
   * Возвращает пользователя по идентификатору
   * @param employeeId - идентификатор пользователя
   */
  public get(employeeId: number): Observable<CustomerEmployeeShort> {
    const relativeUrl = `${AppUrls.commonServices.employee.getUrl}${employeeId}`;
    // TODO 15.04.25 Литвиненко: временно, заменить на getAbsoluteUrl после добавления апи в participantoffers
    const absoluteUrl = this.urlBuilder.getTenderPlatformAbsoluteUrl(relativeUrl);

    return this.http.get<CustomerEmployeeShort>(absoluteUrl);
  }
}
